import { render, staticRenderFns } from "./RecheckDrafts.vue?vue&type=template&id=68b406b5&scoped=true"
import script from "./RecheckDrafts.vue?vue&type=script&lang=ts"
export * from "./RecheckDrafts.vue?vue&type=script&lang=ts"
import style0 from "./RecheckDrafts.vue?vue&type=style&index=0&id=68b406b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b406b5",
  null
  
)

export default component.exports